const INITIAL_STATE = {
    perguntasPorNegocio: [],
}

export default function Perguntas(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'PERGUNTAS_NEGOCIO_FETCHED' :
            return { ...state, perguntasPorNegocio: action.payload }
        default :
            return state
    }
}